'use strict';

function getCashboxLabel(cashbox, shorten = true) {
  if (!cashbox) return '';
  if (cashbox.id == 1) {
    return 'Principal';
  } else if (cashbox.id == 2) {
    return 'Tesoreria';
  } else if (cashbox.id == 3) {
    return 'Vales';
  } else {
    if (shorten) {
      return cashbox.employee.name
        .split(' ')
        .map(n => n.slice(0, 2))
        .join('');
    } else {
      return cashbox.employee.name;
    }
  }
}

// eslint-disable-next-line no-unused-vars
function CashboxLabel($filter) {
  'ngInject';
  return {
    restrict: 'E',
    scope: {
      cashbox: '=',
      shorten: '='
    },
    // eslint-disable-next-line no-unused-vars
    link: function(scope, elem, attr, ctrl) {
      const { cashbox, shorten } = scope;
      const label = getCashboxLabel(cashbox, shorten);

      scope.cashboxLabel = label;
    },
    template: '{{ cashboxLabel }}'
  };
}

export { CashboxLabel as default, getCashboxLabel };
